const profileVisible = () => {
	const profile = document.querySelector('.profile')
	profile.classList.toggle('profile_show')
}
const init = () => {
	const profile_link = document.querySelector('.profile_link')
	const profile_close = document.querySelector('.profile__close')

	if(profile_link) {
		profile_link.addEventListener('click', function (e) {
			e.preventDefault()
			profileVisible()
		})
	}

	if(profile_close) {
		profile_close.addEventListener('click',  () => profileVisible())
	}
}

export default {
	init,
};
